import en from "commonAssets/i18n/en";
import merge from "lodash/merge";

const overrides = {
    admin_email: "Email: ",
    admin_phone: "Phone: ",
    chatbot: {
        for_fastest_response:
            "For fastest response, try using our chat bot at the bottom left, most questions can be answered there.",
    },
    claim_edit_instructions:
        "Please update any claim fields and then click Submit on the bottom of this page to update your Payment Method Selection.",
    claim_edit_notice:
        'Filed a claim? <a href="javascript:void(0);" id="editClaimBtn">Click here</a> to edit your claim.',
    claim_edit_title: "Edit Payment Method Selection",
    claim_form_errors: "There are errors on the Payment Method Selection.",
    claim_processing_email_error:
        "Your contact email address must match the email address provided in your payment method selection. Please update your primary email or telephone number in the Contact Information section to match your payment information.",
    claim_processing_error:
        "There was an error processing your request, please refresh the page and try again.",
    claim_processing_phone_error:
        "Your contact phone number must match the phone number provided in your payment method selection.",
    claim_submit_error:
        "There was an error submitting your claim, please try again.",
    claim_submit_success: "Thank you, your claim has been submitted.",
    close: "Close",
    confirmation: "Confirmation",
    confirmation_page: {
        title: "Your Payment Method Selection has been submitted successfully.",
        upload_fail: "",
        print_note: "Please print this page for your records.",
        claim_details: {
            title: "Your Payment Method Selection Details",
            body: "PAYMENT METHOD SELECTION INFORMATION",
            footer: '<p class="text-center fs-6">If you have any questions regarding your Payment Method Selection, please provide the Submitted Correlation ID listed above when contacting the Settlement Administrator.</p>',
            edit: "",
        },
    },
    confirmation_exclusion_page: {
        title: "Your Opt-Out Request has been submitted successfully.",
        upload_fail: "",
        print_note: "Please print this page for your records.",
        claim_details: {
            title: "Your Opt-Out Details",
            body: "OPT-OUT INFORMATION",
            footer: '<p class="text-center fs-6">If you have any questions regarding your Opt-Out Request, please contact the Settlement Administrator.</p>',
            edit: "",
        },
    },
    confirmation_this_is_a_copy: "THIS IS A COPY OF YOUR PAYMENT METHOD SELECTION",
    confirmation_screen_additional: {
        title: "Notice",
        body: '<p class="fw-bold">You have successfully submitted your Payment Method Selection.</p>',
    },
    contact_admin: "Contact Settlement Administrator",
    contact_us_category: "Category",
    contact_us_error_while_sending:
        "An error occurred while sending your message. Please try again later.",
    contact_us_fill_required_fields: "Please fill out all required fields.",
    contact_us_rel_faqs: "Relevant FAQ",
    contact_us_confirm: "Does this answer your question?",
    contact_us_select_a_reason: "Select a reason",
    contact_us_select_dropdown: {
        claim_form: "Payment Method Selection",
        contact_info_update: "Contact Information Update",
        exclusion: "Exclusion & Opt-Out",
        general_qa: "General Question About the Settlement",
        notice_related: "Notice Related",
        other: "Other",
        payment: "Payment",
        status: "Status",
    },
    contact_us_select_other: "Other",
    contact_us_success: "Your message has been sent successfully.",
    contact_us: "Contact Us",
    custom_fb_association:
        "Please enter at least one Email, Phone Number, or Username associated with your Facebook account.",
    date: "Date",
    deadline_claim: "The deadline to submit a Payment Method Selection has passed.",
    deadline_exclude: "The deadline to submit an exclusion has passed.",
    transaction_add_row: "Add ",
    transaction_delete_row: "Delete Row",
    email_address: "Email Address",
    error: "Error",
    error_403:
        "Your current computer configuration and/or usage is in violation with our security policies. Please disable VPNs or try on a different device.",
    example: "Example",
    exclusion_form_top_notice:
        "By submitting this Opt-Out Form I am requesting exclusion from this Settlement, and I will not receive a Settlement payment.",
    exclusion_form_error: "There are errors on the Opt-Out Request Form.",
    exclusion_submit_error:
        "There was an error submitting your Opt-Out Request, please refresh the page and try again.",
    exclusion_submit_success:
        "Your Opt-Out Request has been submitted successfully.",
    first_name: "First Name",
    faq_page_aria_title: "Frequently Asked Questions",
    important_dates: "Important Dates",
    last_name: "Last Name",
    locale: "en-US",
    long_date: "Hearing",
    message: "Message",
    nav_submit_claim_button: "Update My Payment Method",
    no: "No",
    not_eligible_submit_claim: "You are not eligible to submit a claim.",
    notice: "Notice",
    official_banner_text:
        "This is the official Settlement Website for the {SiteName} authorized by the {CourtName}.",
    official_banner_aria: "Official settlement website notice",
    otp_instructions_1: "A one-time passcode has just been emailed to",
    otp_instructions_2:
        "Please enter the 6 digit code below to access your claim form.",
    otp_invalid_error: "The code you entered is not valid. Please try again.",
    otp_title: "One-Time Passcode",
    otp_validation_error: "Please enter the full 6 digit code.",
    payment_select_email_disclaimer:
        "Please make sure the email or phone number you provide to receive payment matches your contact information above.",
    payment_select_error: "Please select a Payment Method.",
    payment_update_message:
        'You have successfully requested a <span id="previous_payment_method"></span> payment. <span id="update_payment_toggle">Click here if you would like to choose a different payment method.</span>',
    phone_number_1: "Phone Number",
    claim_id_if_known: "Claim ID (if known)",
    privacy_policy_url:
        "https://angeion-public.s3.amazonaws.com/docs/Privacy_Policy.pdf",
    privacy_policy: "Privacy Policy",
    reason_select: "Select a reason",
    reason: "Reason",
    required: "Required",
    return_to_home: 'Return to <a href="home">home page</a>.',
    signature: "Signature",
    signature_placholder: "TYPE YOUR FULL NAME",
    signature_ueta_title: "Electronic Signature Notice",
    signature_ueta_compliant:
        "By typing your name below and submitting this form, you agree that this constitutes your electronic signature.",
    submit_btn: "Submit",
    submitting: "Submitting...",
    topic: "Topic",
    version: "Version",
    yes: "Yes",
    vpn_cors_error:
        '<div class="vpn-error-container"><p>We\'re sorry, but we were unable to process your request due to a security restriction or network-related issue.</p><p>This could be caused by one of the following:</p><ul><li>Your IP address originates from a restricted geographic region</li><li>You are using a VPN, proxy, or anonymizing service</li><li>Your connection triggered a security rule designed to protect our systems</li><li>There was a problem reaching our servers (e.g. browser or connection error)</li></ul><p>If you believe this was an error and you need access, please contact our support team and include the following:</p><ul><li>Your IP address</li><li>The date and time of the issue</li><li>A brief description of what you were trying to access</li></ul><p>Thank you for your understanding and cooperation.</p></div>',
    access_issue_detected: "Access Issue Detected",
};


export default { en: merge(en, overrides) };
